import { EventEmitter, inject, signal } from '@angular/core';
import { AppStateService, HttpErrorService, ShortTermRentalCheckoutService } from '../../../services';
import { distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProcessOrderResponse, STRCheckoutTotals } from '../../../models';
import { PaymentStatus, PaymentType, PublicRoutes } from '../../../enums';
import { MessageService } from 'primeng/api';
import { NavigationExtras, Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit,
 * @Input({ required: true })
 * override completeUrl: string = '';
 * 
 * @Input()
 * override userMustClickIAgree = false;
 * 
 * @Output()
 * override showTerms = new EventEmitter<void>();
 */
export abstract class NgxAimOverviewRentalsClass {
  // ngOnInit() {
  //   this.init();
  // }

  checkoutService = inject(ShortTermRentalCheckoutService);
  httpErrorService = inject(HttpErrorService);
  appState = inject(AppStateService);
  messageService = inject(MessageService);
  router = inject(Router);

  completeUrl: string = PublicRoutes.RENTAL_COMPLETE;
  showTerms = new EventEmitter<void>();
  userMustClickIAgree = false;
  iAgree = false;

  totals$ = this.checkoutService.totals$.pipe(
    distinctUntilChanged(),
    takeUntilDestroyed(),
  );
  totals: STRCheckoutTotals = {
    items: 0,
    shipping: 0,
    tax: 0,
    total: 0,
    tax2: 0,
    taxTotal: 0,
  }
  rentalData = this.checkoutService.getRentalData();
  strData$ = this.checkoutService.strData$;
  isProcessing = false;
  showError = false;
  taxName = signal('Tax');
  tax2Name = signal('');

  init() {
    this.totals$.subscribe(totals => {
      this.totals = totals;
    });

    if (this.rentalData.subCategory.taxName) {
      this.taxName.set(this.rentalData.subCategory.taxName);
    }

    if (this.rentalData.subCategory.tax2Name) {
      this.tax2Name.set(this.rentalData.subCategory.tax2Name);
    }
  }

  onCompleteClick() {
    if (this.appState.paymentType === PaymentType.NONE && this.totals.total !== 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Failed',
        detail: 'Cannot not check out at this time. No payment processor',
        key: 'app-toast'
      });
      return;
    }

    this.isProcessing = true;
    this.checkoutService.checkout().subscribe({
      next: (res) => this.handleCheckoutResponse(res),
      error: (err) => this.onError(err),
    });
  }

  handleCheckoutResponse(res: ProcessOrderResponse) {
    this.isProcessing = false;
    if (res.paymentStatus === PaymentStatus.APPROVED) {
      this.checkoutService.reset();

      const navigationExtras: NavigationExtras = {
        state: {
          orderId: res.orderId,
        },
      }
      this.router.navigate(['/', this.completeUrl], navigationExtras);
    } else {
      this.showError = true;
    }
  }

  onTermsClick($event: any) {
    $event.preventDefault();
    $event.stopPropagation();
    this.showTerms.next();
  }

  onError(err: any) {
    this.isProcessing = false;
    this.httpErrorService.onHttpError(err, `We couldn't process your order`);
  }
}
